import { ApiBase } from "./api-base.interface";

export class Feedback extends ApiBase {
    comments;
    rating?: number = null;
}
